export class BaseApiError extends Error {
  public status: number;
  public isServerError: boolean;

  constructor(message: string, status: number) {
    super(message);
    this.name = 'BaseApiError';
    this.status = status;
    this.isServerError = status >= 500;
  }
}
